import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isPrimaryDomain", "onRemoveDomain", "onPromoteDomain"];
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import DomainInput from './DomainInput';
import { Flex } from 'foundations-components/components/Flex';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ExistingValue(props) {
  const {
    value,
    onRemoveDomain,
    onPromoteDomain,
    isPrimaryDomain
  } = props;
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    "data-test-id": "existing-domain-value",
    gap: "500",
    children: [/*#__PURE__*/_jsx(DomainInput, Object.assign({}, rest)), /*#__PURE__*/_jsx(Flex, {
      children: isPrimaryDomain ? /*#__PURE__*/_jsx(Tag, {
        marginInline: "300",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "customerDataProperties.PropertyInputMultipleDomain.primaryDomainTag"
        })
      }) : /*#__PURE__*/_jsx(UIDropdown, {
        buttonUse: "transparent",
        buttonText: unescapedText('customerDataProperties.PropertyInputMultipleDomain.actions'),
        children: /*#__PURE__*/_jsxs(UIList, {
          children: [/*#__PURE__*/_jsx(UIButton, {
            use: "transparent",
            size: "extra-small",
            onClick: () => {
              onPromoteDomain(value);
            },
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "customerDataProperties.PropertyInputMultipleDomain.makePrimary"
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            use: "transparent",
            size: "extra-small",
            onClick: () => {
              onRemoveDomain(value);
            },
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "customerDataProperties.PropertyInputMultipleDomain.delete"
            })
          })]
        })
      })
    })]
  });
}
export default ExistingValue;